import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiClientService } from '@tablesready/api-client';

@Injectable()
export class RestorePasswordService {
  private readonly basPath = '/password-restore'

  constructor(private readonly http: ApiClientService) {
  }

  checkCode(code: string): Observable<boolean> {
    return this.http.post(`${this.basPath}/${code}`, {})
      .pipe(
        map(() => true),
        catchError(() => of(false)),
      );
  }

  setPassword(code: string, password: string) {
    return this.http.post(this.basPath, {code, password});
  }
}
